import { render, staticRenderFns } from "./ListMenuP2.vue?vue&type=template&id=9c500086&"
import script from "./ListMenuP2.vue?vue&type=script&lang=js&"
export * from "./ListMenuP2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports